import { Component, input } from '@angular/core';

@Component({
  selector: 'fx-dynamic-tabular-table-empty-state',
  standalone: true,
  template: `
    <div class="py-16 text-center text-gray-500">
      <p>Esta tabela está vazia.</p>
      @if (!readonly()) {
        <p class="mt-2 text-sm">
          Clique em "Adicionar Linha" ou "Adicionar Coluna" para começar, ou cole dados CSV
          diretamente.
        </p>
      }
    </div>
  `,
})
export class FxDynamicTabularTableEmptyStateComponent {
  public readonly readonly = input<boolean>(false);
}
